import { useEffect, useState } from 'react';
import integrationService from '../../services/integration.service';
import { OAUTH_MESSAGE_TYPE, readOAuthReturn } from '../../utils/oauthCallback';
import './OAuthCallback.scss';

function notifyOpener(payload: Record<string, unknown>) {
  try {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(payload, '*');
    }
  } catch {
    // YouCan a coupé window.opener.
  }
  try {
    const channel = new BroadcastChannel('zeedcom-oauth');
    channel.postMessage(payload);
    channel.close();
  } catch {
    // BroadcastChannel indisponible.
  }
}

function currentStoreId(): number | null {
  try {
    const id = JSON.parse(localStorage.getItem('currentStore') || 'null')?.id;
    const parsed = Number(id);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
}

/**
 * YouCan coupe le lien avec la boutique. Cette page échange donc le code
 * elle-même, puis ferme la fenêtre.
 */
const OAuthCallback: React.FC = () => {
  const [message, setMessage] = useState('Connexion en cours…');

  useEffect(() => {
    let cancelled = false;
    const landing = readOAuthReturn(window.location.search);
    const params = new URLSearchParams(window.location.search);
    const error = landing?.error || params.get('error');
    const errorDescription = landing?.errorDescription || params.get('error_description');

    const closePopup = () => {
      window.close();
    };

    const run = async () => {
      if (error) {
        const text = errorDescription ? `${error}:${errorDescription}` : error;
        localStorage.setItem('oauth_pending_error', text);
        notifyOpener({
          type: OAUTH_MESSAGE_TYPE,
          error,
          errorDescription,
          state: landing?.state || params.get('state'),
          integrationKey: landing?.integrationKey || params.get('integration')
        });
        if (!cancelled) setMessage('Autorisation refusée. Vous pouvez fermer cette fenêtre.');
        closePopup();
        return;
      }

      if (!landing?.code || !landing.integrationKey) {
        if (!cancelled) setMessage('Autorisation incomplète. Fermez cette fenêtre et réessayez.');
        return;
      }

      notifyOpener({
        type: OAUTH_MESSAGE_TYPE,
        code: landing.code,
        state: landing.state,
        integrationKey: landing.integrationKey
      });

      if (localStorage.getItem('oauth_accepted_state') === landing.state) {
        closePopup();
        return;
      }

      const expected = localStorage.getItem('oauth_state');
      const storeId = currentStoreId();
      if (!localStorage.getItem('accessToken') || !storeId || expected !== landing.state) {
        window.setTimeout(() => {
          if (cancelled) return;
          if (localStorage.getItem('oauth_accepted_state') === landing.state) {
            closePopup();
            return;
          }
          setMessage('La boutique n’a pas reçu l’autorisation. Fermez cette fenêtre et réessayez.');
        }, 4000);
        return;
      }

      localStorage.setItem('oauth_accepted_state', landing.state);
      localStorage.removeItem('oauth_pending_code');
      localStorage.removeItem('oauth_pending_state');
      localStorage.removeItem('oauth_pending_error');

      try {
        await integrationService.completeOAuth(
          storeId,
          landing.integrationKey,
          landing.code,
          landing.state
        );
        localStorage.removeItem('oauth_state');
        localStorage.removeItem('oauth_integration');
        localStorage.setItem('oauth_finished', landing.state);
        if (!cancelled) setMessage('Boutique connectée.');
        closePopup();
      } catch {
        localStorage.removeItem('oauth_accepted_state');
        if (!cancelled) setMessage('La connexion n’a pas abouti. Fermez cette fenêtre et réessayez.');
      }
    };

    void run();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="oauth-callback">
      <p>{message}</p>
    </div>
  );
};

export default OAuthCallback;
